import React from 'react';
import { MenuItem } from '@one-thd/sui-atomic-components';
import proptypes from 'prop-types';
import { DropdownItem } from './dropdown-item';

const { string, bool, func } = proptypes;

export const Dropdown = (props) => {
  const {
    isAvailable,
    onClick,
    value,
    swatchGuid
  } = props;

  return (
    <MenuItem
      value={value}
      onClick={onClick}
    >
      <DropdownItem swatchGuid={swatchGuid} attributeValue={value} isDisabled={!isAvailable} />
    </MenuItem>
  );
};

Dropdown.displayName = 'Dropdown';

Dropdown.propTypes = {
  value: string.isRequired,
  isAvailable: bool.isRequired,
  swatchGuid: string,
  onClick: func.isRequired
};

Dropdown.defaultProps = {
  swatchGuid: null
};